// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12DwC","right":"styles_right__2-sUW"};